/** @module url */ /** for typedoc */
export * from "./urlMatcher";
export * from "./urlMatcherConfig";
export * from "./urlMatcherFactory";
export * from "./urlRouter";



/** WEBPACK FOOTER **
 ** ./url/module.ts
 **/